import { render, staticRenderFns } from "./dec.vue?vue&type=template&id=09555f15"
import script from "./dec.vue?vue&type=script&lang=js"
export * from "./dec.vue?vue&type=script&lang=js"
import style0 from "./dec.vue?vue&type=style&index=0&id=09555f15&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports